function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.461 31.0762C90.1007 33.5529 88.1005 35.6152 86.0158 37.5265C83.1914 40.1172 80.1655 42.4888 76.9758 44.612C75.4241 45.6459 73.9115 46.7466 72.504 47.9707C68.06 51.834 65.445 57.0306 61.8368 61.6127C58.9225 65.3115 55.388 68.4657 51.8652 71.5894C47.6135 75.3606 43.316 79.1266 38.5618 82.2634C35.7605 84.1101 32.8924 85.9463 29.7547 87.169C27.678 87.9783 23.6203 89.3268 21.4606 87.8431C20.7468 86.2234 20.4825 84.4749 20.9296 82.9735C21.3389 81.6029 22.117 80.374 22.9586 79.2162C27.1112 73.4924 33.0188 68.971 35.939 62.5322C37.3134 59.4992 37.9701 56.1397 39.7012 53.2935C39.9095 52.95 40.137 52.6048 40.2121 52.2109C40.278 51.8556 40.2139 51.4909 40.1968 51.1305C40.068 48.5692 42.2093 46.4056 42.4891 43.8574C42.5263 43.5199 42.5318 43.1716 42.6617 42.8583C42.8054 42.5168 43.0837 42.2474 43.2405 41.9116C43.3984 41.5748 43.7456 41.3556 43.4126 41.1924C42.9083 38.2653 42.4997 35.3266 42.0996 32.3831C41.8793 30.7593 40.2008 28.1723 42.6097 27.4708C43.7666 27.1349 46.7235 25.914 47.8323 26.8481C48.0641 27.0439 48.2108 27.319 48.4005 27.5562C49.5148 28.9411 51.0581 27.8873 52.4039 28.5843C53.7108 29.262 53.6686 31.1171 53.44 32.5728C54.9739 30.2619 57.7031 29.0385 60.3899 28.3598C63.0779 27.6801 65.8791 27.4214 68.479 26.455C71.0775 25.4918 73.5573 23.6172 74.2755 20.9393C74.5647 19.8615 74.5501 18.7225 74.7951 17.634C75.0414 16.5444 75.6365 15.4288 76.6793 15.0307C76.2742 14.2673 76.3831 13.2613 76.9459 12.6033C78.4142 10.8812 80.3576 12.5227 81.4809 13.6827C83.1102 15.3646 85.394 16.3866 87.2064 17.8661C88.9943 19.3288 89.7589 21.6991 91.6918 23.0574C92.1005 23.3437 92.5124 23.4824 92.9301 23.5935C93.3645 26.1338 92.708 28.8038 91.461 31.0762Z",
  fill: "#5D79C2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.088 40.7622C51.695 41.4896 52.7766 41.5872 53.5042 40.9801C54.2329 40.372 54.3306 39.2905 53.7235 38.5631C53.1165 37.8356 52.0349 37.7381 51.3061 38.3462C50.5786 38.9533 50.4809 40.0348 51.088 40.7622Z",
  fill: "#1B1535"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.733 47.1963C49.34 47.9237 50.4216 48.0213 51.1504 47.4132C51.878 46.8061 51.9756 45.7246 51.3686 44.9971C50.7615 44.2697 49.6789 44.1709 48.9513 44.778C48.2226 45.3861 48.1259 46.4688 48.733 47.1963Z",
  fill: "#1B1535"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.389 53.8596C45.9961 54.587 47.0776 54.6846 47.8052 54.0775C48.534 53.4694 48.6304 52.3889 48.0233 51.6614C47.4163 50.934 46.3359 50.8354 45.6072 51.4435C44.8796 52.0506 44.7819 53.1321 45.389 53.8596Z",
  fill: "#1B1535"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.725 59.9399C42.3321 60.6674 43.4147 60.7661 44.1434 60.158C44.871 59.551 44.9676 58.4682 44.3606 57.7408C43.7535 57.0134 42.6719 56.9158 41.9444 57.5229C41.2156 58.131 41.118 59.2125 41.725 59.9399Z",
  fill: "#1B1535"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.1527 65.9045C38.7598 66.6319 39.8413 66.7295 40.5689 66.1224C41.2964 65.5153 41.3941 64.4338 40.787 63.7064C40.18 62.9789 39.0974 62.8802 38.3698 63.4872C37.6423 64.0943 37.5456 65.177 38.1527 65.9045Z",
  fill: "#1B1535"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M52.7654 39.3808C50.7316 39.3655 48.748 40.0952 47.0025 41.1376C44.2676 42.7736 38.851 46.2953 40.2807 50.1128",
  stroke: "#1B1535",
  strokeWidth: 0.653977,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.6267 46.2196C47.0691 46.2295 43.4444 48.7074 40.8379 50.8967C40.2078 51.4245 39.5938 51.9866 39.1572 52.6842C38.7218 53.3809 38.4791 54.2314 38.655 55.0329",
  stroke: "#1B1535",
  strokeWidth: 0.653977,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.5099 52.8345C46.911 52.4791 46.1515 52.7526 45.5135 53.0303C44.348 53.5369 43.1848 54.0438 42.0205 54.5494C40.5612 55.1853 39.0697 55.8397 37.9113 56.9305C36.7506 58.0212 35.9691 59.6505 36.3119 61.2051",
  stroke: "#1B1535",
  strokeWidth: 0.653977,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43.7201 58.5937C43.3605 58.4507 42.9567 58.5971 42.6 58.7478C40.7609 59.5266 38.9864 60.4524 37.2946 61.512C36.2453 62.1702 35.2163 62.8901 34.4071 63.8262C33.5957 64.762 33.0151 65.9422 32.9924 67.1806",
  stroke: "#1B1535",
  strokeWidth: 0.653977,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.1605 64.1655C37.6376 64.8173 34.443 65.6815 32.3182 67.2495C31.4632 67.8801 30.7709 68.8098 30.6742 69.8677",
  stroke: "#1B1535",
  strokeWidth: 0.653977,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.332 46.8313C48.5643 46.5444 46.8319 46.0292 45.1954 45.3015C44.3174 44.9119 43.4278 44.4265 42.92 43.6121C42.4122 42.7976 42.4459 41.5749 43.2276 41.0179",
  stroke: "#1B1535",
  strokeWidth: 0.653977,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.2169 53.3842C44.9885 52.7859 42.3747 51.882 40.5471 50.4836C40.0013 50.0653 39.3982 49.5312 39.4399 48.8442C39.4709 48.3504 39.8359 47.9465 40.2104 47.6236C40.4784 47.3938 40.7618 47.1801 41.0601 46.9891",
  stroke: "#1B1535",
  strokeWidth: 0.653977,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43.5287 59.6716C41.7239 59.2707 40.0386 58.3331 38.7485 57.008C38.4488 56.701 38.1575 56.352 38.0771 55.9305C37.9748 55.4009 38.2586 54.8204 38.7401 54.576",
  stroke: "#1B1535",
  strokeWidth: 0.653977,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.7121 65.4797C38.3249 64.9539 37.2197 63.8926 36.1539 62.8586C35.8331 62.5486 35.4929 62.203 35.4314 61.7595C35.3378 61.1089 35.8693 60.5473 36.3918 60.1486",
  stroke: "#1B1535",
  strokeWidth: 0.653977,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.4713 63.6757C52.4739 65.1393 57.6689 62.7093 58.9921 57.4313C60.6308 50.9085 61.6278 43.6293 61.6196 36.9072C58.6079 43.4721 58.2547 50.9843 54.6895 57.3277C52.7611 60.7588 49.6427 62.0419 46.085 63.2651C46.5525 63.4009 47.0138 63.5419 47.4713 63.6757Z",
  fill: "white"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.3161 25.231C72.0892 33.1699 72.1973 41.173 71.6391 49.1295",
  stroke: "white",
  strokeWidth: 0.435985,
  strokeLinecap: "round"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.7569 22.3115C75.0978 30.3378 75.7133 38.4848 75.5915 46.6218",
  stroke: "white",
  strokeWidth: 0.435985,
  strokeLinecap: "round"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.4562 87.8449C23.6147 89.3296 27.6724 87.9811 29.7491 87.1717C32.889 85.9493 35.7549 84.1129 38.5574 82.2651C43.3104 79.1294 47.6079 75.3634 51.8596 71.5922C55.3823 68.4685 58.9191 65.3145 61.8312 61.6155C65.4394 57.0333 68.0556 51.8358 72.4996 47.9724C73.9081 46.7495 75.4195 45.6499 76.9712 44.616C80.1611 42.4906 83.187 40.119 86.0124 37.5295C88.0972 35.6182 90.0951 33.5557 91.4566 31.078C92.7034 28.8078 93.3601 26.1356 92.9245 23.5962C93.3533 23.7105 93.7869 23.7959 94.2286 23.9802C95.8404 24.6561 96.6787 25.998 96.9461 27.6486C98.0978 27.5944 99.0159 28.5531 99.7604 29.4329C100.247 30.0084 100.735 30.5828 101.222 31.1573C101.475 31.4555 101.734 31.7655 101.841 32.142C101.944 32.5114 101.888 32.9059 101.812 33.2805C101.118 36.6276 98.5638 39.5226 95.3305 40.6284C95.8073 41.3982 95.1198 42.3487 94.4703 42.9797C92.493 44.9007 90.4217 46.7264 88.2675 48.4452C87.0825 49.3926 85.8643 50.2703 84.4373 50.8109C83.9114 51.0095 83.4171 51.1715 82.8553 51.1931C82.3614 51.2117 81.8661 51.0847 81.6018 51.624C81.2861 52.2581 81.8805 52.9878 81.7871 53.6476C81.7319 54.0455 81.5428 54.4145 81.291 54.7529C80.9199 55.2511 80.4112 55.6838 79.9925 56.0456C78.1035 57.6777 76.212 59.3119 74.3219 60.9428C73.9559 61.2586 73.5768 61.5811 73.1159 61.7235C72.6537 61.8669 72.0859 61.7795 71.8017 61.3894C72.0072 62.5637 71.0077 63.5695 70.1005 64.3409C67.8102 66.2913 65.5211 68.2407 63.2321 70.19C62.9458 70.4351 62.5026 70.6807 62.2315 70.4203C62.5834 70.9487 62.0486 71.6081 61.5583 72.0131C60.6238 72.7866 59.7293 73.6055 58.806 74.3925C57.8219 75.2281 56.2434 77.4831 54.7018 76.7176C54.7508 77.8632 53.7897 78.7686 52.9108 79.502C52.1405 80.1447 51.37 80.7897 50.5997 81.4324C50.0516 81.8898 49.4048 82.3901 48.7843 82.7484C48.4938 82.9163 46.7237 83.1551 46.7561 83.1219C44.6319 85.4451 41.864 87.1729 38.8467 88.0611C36.7725 89.8808 34.3692 91.321 31.788 92.2925C30.2163 92.8855 28.4975 93.3073 26.862 92.9182C24.5924 92.3772 22.5193 90.2602 21.4562 87.8449Z",
  fill: "#1B1535"
});

var SvgBannerShoe2 = function SvgBannerShoe2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 106,
    height: 99,
    viewBox: "0 0 106 99",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBannerShoe2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/banner-shoe-2.2892454e.svg";
export { ForwardRef as ReactComponent };